// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

/**
 * `MediaSection` component.
 */
const MediaSection = ({ baseClassName, className, children, ...props }) => (
    <div className={classNames(baseClassName, className)} {...props}>
        {children}
    </div>
);

MediaSection.propTypes = {
    /**
     * Content of the `MediaSection`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
MediaSection.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}media-section`,
};

export default MediaSection;



// WEBPACK FOOTER //
// ./components/Media/MediaSection.js